<template>
  <div
    :class="[
      ['/login', '/onboarding'].indexOf(this.$route.params.pathMatch) >= 0
        ? ''
        : 'max-1200',
    ]"
    @click="event => this.closeMenu(event)"
  >
    <component :is="currentComponent"></component>
    <notifications group="dashboard-notification" position="top left" />
  </div>
</template>

<script>
import Profile from './dashboard/components/Profile.vue'
import AccountOverview from './dashboard/components/AccountOverview.vue'
import ChangePassword from './dashboard/components/ChangePassword.vue'
import NotificationsSettings from './dashboard/components/Notifications.vue'
import Ownerships from './dashboard/components/ownerships/Ownerships.vue'
import BuildPlusContainer from './dashboard/components/admin/ownerships/BuildPlusContainer.vue'
import PlancheckContainer from './dashboard/components/admin/ownerships/PlancheckContainer.vue'
import PostManagement from './dashboard/components/admin/PostManagement.vue'
import CityPageManagement from './dashboard/components/admin/CityPageManagement.vue'
import VendorsManagement from './dashboard/components/admin/VendorsManagement.vue'
import Analytic from './dashboard/components/analytic/Analytic.vue'
import Login from './dashboard/components/Login.vue'
import Onboarding from './dashboard/components/Onboarding.vue'
import VendorsList from './dashboard/components/vendor/VendorsList.vue'
import VendorDetail from './dashboard/components/vendor/VendorDetail.vue'
import Listings from './dashboard/components/products/Listings.vue'
import PreuploadDesign from './dashboard/components/products/PreuploadDesign.vue'
import DetailedListing from 'src/components/dashboard/components/products/detailed_listing/DetailedListing.vue'
import SymbiumBuild from 'src/components/dashboard/components/products/SymbiumBuild.vue'
import EventBus from 'src/components/EventBus.js'

export default {
  name: 'Dashboard',
  components: { Profile, AccountOverview, Login, NotificationsSettings },
  computed: {
    currentComponent() {
      switch (this.$route.params.pathMatch) {
        case '/profile':
          return Profile
        case '/account_overview':
          return AccountOverview
        case '/change_password':
          return ChangePassword
        case '/notifications':
          return NotificationsSettings
        case '/ownerships':
          return Ownerships
        case '/buildplus_management':
          return BuildPlusContainer
        case '/plancheck_management':
          return PlancheckContainer
        case '/post_management':
          return PostManagement
        case '/city_page_management':
          return CityPageManagement
        case '/vendors_managment':
          return VendorsManagement
        case '/login':
          return Login
        case '/analytics':
          return Analytic
        case '/vendors':
          return VendorsList
        case '/vendor_details':
          return VendorDetail
        case '/listings':
          return Listings
        case '/product/edit':
          return DetailedListing
        case '/onboarding':
          return Onboarding
        case '/build':
          return SymbiumBuild
        case '/preupload_design':
          return PreuploadDesign
        default:
          return AccountOverview
      }
    },
  },
  methods: {
    showLogin() {
      this.$router.push('/dashboard/login')
    },
    closeMenu(event) {
      EventBus.$emit('closeMenu', event)
    },
    setOrganization(data) {
      var org = data.organizations[0]
      if (org) this.$organization.setLocalOrganization(org)
    },
  },
  created() {
    EventBus.$on('user-unauthorized', this.showLogin)
    EventBus.$on('user-fetched', this.setOrganization)
  },
  beforeDestroy() {
    EventBus.$off('user-unauthorized', this.showLogin)
    EventBus.$off('user-fetched', this.setOrganization)
  },
}
</script>

<style lang="scss">
.circle {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #21275b;
  border-radius: 50%;
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.dashboard-content-container,
.dashboard-content-container * {
  font-family: Inter;
  font-style: normal;
}

.dashboard-content-container {
  margin: 64px 24px 0;

  .content {
    width: 100%;
  }

  .dashboard-content-middle {
    width: 1200px;
    margin: auto;
  }

  .section {
    margin-bottom: 32px;
  }

  .section-field {
    padding: 32px 0 48px;
    border-top: 1px solid #dddddd;

    .left {
      max-width: 300px;
      min-width: 300px;
    }

    .right {
      flex-grow: 1;
    }

    .half-left {
      width: 402px;
      margin-right: 48px;
    }

    .big-half-left {
      width: 546px;
    }

    .text-align-right {
      flex-grow: 1;
      text-align: right;
    }
  }

  .section-footer {
    padding: 16px 24px;
    text-align: right;
    align-items: center;
  }

  .loadable-content {
    padding: 24px;
  }
}

.vue-notification {
  width: 100%;

  &.error {
    background: #f1574b;
  }

  &.error * {
    color: white;
  }
}

@media screen and (max-width: 768px) {
  .dashboard-content-container {
    .content {
      width: 100%;
      height: fit-content;
      overflow-y: scroll;
    }

    .page-container {
      flex-wrap: wrap;
    }

    .dashboard-content-middle {
      width: 100%;
      margin: auto;
    }

    .section-field {
      display: block;
      padding: 24px 0 32px;
      overflow: hidden;

      .left,
      .right {
        width: 100%;
        padding: 0;
      }
    }
  }
}

.link-purple {
  text-decoration: none;
  cursor: pointer;
  color: var(--purple);

  &:hover,
  &:focus,
  &:visited,
  &:active {
    text-decoration: underline;
    color: var(--purple);
  }
}

.pull-left {
  min-width: 300px;
  max-width: 300px;
  padding-right: 24px;
}

.pull-right {
  min-width: 60%;
  max-width: calc(100% - 300px);
}

@media screen and (max-width: 1068px) {
  .pull-left {
    max-width: 100%;
    padding: 0;
  }
  .pull-right {
    max-width: 100%;
  }
}
</style>
